import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Grid,
  DialogActions,
} from '@material-ui/core';
import FilterAutoComplete from "../../shared/FilterAutoComplete";

const toOption = ({id, team_name, name, crd_id, created_at}) => ({
  id,
  name: `${team_name || name} ${crd_id ? "(" + crd_id + ")" : ""}`,
  created_at,
});

const TeamMerger = ({open, close, body, team, teams, handleMerge, ...props}) => {
  const teamOptions = [team, ...(teams || [])].filter(Boolean).map(toOption);

  // The oldest group always survives a merge, so its historical data (AUM
  // aggregations, accolades, change log) never ends up on the hidden side.
  const primaryTeam = teamOptions.reduce((oldest, option) => (
    !oldest || (option.created_at && (!oldest.created_at || option.created_at < oldest.created_at)) ? option : oldest
  ), null);

  const [teamsToMerge, setTeamsToMerge] = useState([]);
  const teamsToMergeOptions = teamOptions.filter((option) => option?.id !== primaryTeam?.id);

  useEffect(() => {
    setTeamsToMerge([]);
  }, [team, teams]);

  const onTeamsChange = (value) => {
    setTeamsToMerge(value);
  }

  const onMerge = async (event) => {
    event.persist();
    event.preventDefault();

    if (window.confirm(`You are about to merge ${teamsToMerge.map(({name}) => name).join(", ")} into ${primaryTeam?.name} (the group created first) are you sure you'd like to proceed?`)) {
      handleMerge(primaryTeam, teamsToMerge);
      close();
    }
  }

  const onClose = () => {
    close();
  }

  return <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      className={"dialog"}
      maxWidth={"md"}
  >
    <DialogTitle id="form-dialog-title" disableTypography>
      <h4 className={"dialog-title"}>Merge Groups</h4>
    </DialogTitle>
    <DialogContent dividers>
      <DialogContentText>
        {body}
      </DialogContentText>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FilterAutoComplete
              options={primaryTeam ? [primaryTeam] : []}
              handleOnChange={() => {}}
              selected={primaryTeam}
              label={'Primary Group (created first — stays live)'}
              field={'team'}
              disabled={true}
          />
        </Grid>
        <Grid item xs={6}>
          <FilterAutoComplete
              options={teamsToMergeOptions || []}
              handleOnChange={(value) => onTeamsChange(value)}
              selected={teamsToMerge}
              multiple={true}
              label={'Groups to Merge'}
              field={'teams'}
          />
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
      <Button color="primary" variant="contained" onClick={onMerge} disabled={teamsToMerge.length === 0}>Merge</Button>
    </DialogActions>
  </Dialog>
}

export default TeamMerger;